var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-apple",
    transform: "translate(-14.000000, -10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2226562,14.3846154 C23.0546875,14.3846154 24.0976562,13.8048315 24.71875,13.0317864 C25.28125,12.3312142 25.6914062,11.352829 25.6914062,10.3744437 C25.6914062,10.2415766 25.6796875,10.1087095 25.65625,10 C24.7304687,10.0362365 23.6171875,10.640178 22.9492187,11.4494596 C22.421875,12.06548 21.9414062,13.0317864 21.9414062,14.0222505 C21.9414062,14.1671964 21.9648438,14.3121424 21.9765625,14.3604577 C22.0351562,14.3725366 22.1289062,14.3846154 22.2226562,14.3846154 Z M19.2929688,29 C20.4296875,29 20.9335938,28.214876 22.3515625,28.214876 C23.7929688,28.214876 24.109375,28.9758423 25.375,28.9758423 C26.6171875,28.9758423 27.4492188,27.792117 28.234375,26.6325493 C29.1132812,25.3038779 29.4765625,23.9993643 29.5,23.9389701 C29.4179688,23.9148125 27.0390625,22.9122695 27.0390625,20.0979021 C27.0390625,17.6579784 28.9140625,16.5588048 29.0195312,16.474253 C27.7773438,14.6382708 25.890625,14.5899555 25.375,14.5899555 C23.9804688,14.5899555 22.84375,15.4596313 22.1289062,15.4596313 C21.3554688,15.4596313 20.3359375,14.6382708 19.1289062,14.6382708 C16.8320312,14.6382708 14.5,16.5950413 14.5,20.2911634 C14.5,22.5861411 15.3671875,25.013986 16.4335938,26.5842339 C17.3476562,27.9129053 18.1445312,29 19.2929688,29 Z",
    id: "\\uF8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.65655ce24cbd58508dfadd3e7f21520e.svg";
export { ForwardRef as ReactComponent };